import React from "react";
import styles from './HeaderBanner.module.scss'
import { convertToModule } from "factory/utils/clientUtils";
import OwlCarousel from "utility/templates/owlCarousel";

const HeaderBanner = (props) => {
    return (
        <div className={`${convertToModule(styles, 'header-banner-container')} ${convertToModule(styles, 'banner-pg-cntnr')}`}>
            {
                props.isMobile ?
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" onClick={() => { window.history.go(-1); return false; }} className={convertToModule(styles, 'back-button')}>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.29289 12.7071C7.90237 12.3166 7.90237 11.6834 8.29289 11.2929L14.2929 5.29289C14.6834 4.90237 15.3166 4.90237 15.7071 5.29289C16.0976 5.68342 16.0976 6.31658 15.7071 6.70711L10.4142 12L15.7071 17.2929C16.0976 17.6834 16.0976 18.3166 15.7071 18.7071C15.3166 19.0976 14.6834 19.0976 14.2929 18.7071L8.29289 12.7071Z" fill="white" />
                    </svg>
                    : <></>
            }
            <OwlCarousel
                className="home-slider-M Home-slider-refral"
                margin={0}
                items={1}
                slideBy={1}
                dots={false}
                nav={false}
                loop={false}
                autoplay={false}
                autoplayTimeout={3000}
                slidesPerViewProp={'auto'}
                responsive={true}
            >
                {
                    props.pgBanner.map((eachBanner, index) => {
                        return (
                            <React.Fragment key={'bnr_' + index}>
                                {
                                    eachBanner.imgItm && eachBanner.imgItm.imageUrl ?
                                        <img src={eachBanner.imgItm.imageUrl}  alt="ReferEranBanner" className={convertToModule(styles, 'refer-earn-banner')} />
                                        : <></>
                                }
                            </React.Fragment>
                        )
                    })
                }
            </OwlCarousel>
        </div>
    )

}
export default HeaderBanner;